// Browser-safe extract constants: this module must stay dependency-free. The client imports it
// by deep path (the @civilgrid/utils root entry pulls Node-only modules and initializes caches
// at load, so the client can never import the barrel for these).

/** Layer-id prefix marking a custom-data layer in extract payloads (`customData:<id>`). */
export const CUSTOM_DATA_LAYER_ID_PREFIX = 'customData:';

/** Layer-id prefix marking a site-data layer (potholes / field notes) in extract payloads. */
export const SITE_DATA_LAYER_ID_PREFIX = 'siteData:';

/** Layer id selecting the project's potholes. */
export const SITE_DATA_POTHOLES = 'siteData:potholes';

/** Layer id selecting the project's field notes (note + image + video items). */
export const SITE_DATA_FIELD_NOTES = 'siteData:fieldNotes';

/** `projectGeoItems.type`s each site-data layer exports; shared by GeoJSON serialization and media presign. */
export const SITE_DATA_GEO_ITEM_TYPES: Record<string, string[]> = {
  [SITE_DATA_POTHOLES]: ['potholeLog'],
  [SITE_DATA_FIELD_NOTES]: ['note', 'image', 'video'],
};

/**
 * Gates custom-data layers in the FME export flow. Declared here rather than beside the server
 * helper in `utilities/featureFlags.ts` so the client hook reads the same literal — the client
 * cannot import that module, and a second copy of the key drifts silently into a flag PostHog
 * does not know, which reads as off.
 */
export const EXPORT_CUSTOM_DATA_FLAG = 'export-custom-data-enabled';

/**
 * Route segment for the export history tab, shared because the extract emails link straight to it
 * and the client owns the route — a literal in either place drifts and breaks links already sent.
 */
export const EXPORT_HISTORY_TAB_SEGMENT = 'exports-history';
